import {urls, api} from '@/api'

export default {
  resetInitialState: ({commit}) => {
    commit('RESET_SELL_INITIAL_STATE')
    return Promise.resolve()
  },

  createDraft: ({commit, state, rootState, getters, dispatch}, id) => {
    commit('SET_SELL_MLA_CATEGORY_ID', id)

    const formData = {
      mla_category_id: state.mla_category_id,
      title: state.title,
      body: state.body,
      price: state.price,
      enable_questions: state.enable_questions,
      attributes: getters.attributes
    }

    return api.post(urls.sell, formData)
      .then(({data}) => {
        commit('SET_SELL_ID', data.data.publication_id)
        commit('SET_SELL_CATEGORY_PATH', data.data.category_path)
        commit('SET_SELL_CATEGORY_ID', data.data.category_id)
        commit('SET_SELL_OTHERS', { auto_republication: data.data.auto_republication })
        commit('SET_SELL_OTHERS', { type: data.data.type })
        commit('SET_SELL_CATALOG_DOMAIN', data.data.catalog_domain)
        commit('SET_CAT_MARKETABLE', data.data.category_marketable)
      })
      .catch(err => { return Promise.reject(err) })
  },

  setDraft: ({commit, dispatch}, data) => {
    commit('SET_SELL_ID', data.data.publication_id)
    commit('SET_SELL_PUB_STATUS', data.data.status)
    commit('SET_SELL_TITLE', data.data.title)
    commit('SET_SELL_BODY', data.data.body)
    commit('SET_SELL_PRICE_VALUE', data.data.price.currency_value)
    commit('SET_SELL_PRICE_CURRENCY', data.data.price.currency_code)
    commit('SET_SELL_CATEGORY_ID', data.data.category_id)
    commit('SET_SELL_CATEGORY_PATH', data.data.category_path)
    commit('SET_SELL_MLA_CATEGORY_ID', data.data.mla_category_id)
    commit('SET_SELL_OTHERS', { enable_questions: data.data.enable_questions })
    commit('SET_SELL_OTHERS', { auto_republication: data.data.auto_republication })
    commit('SET_SELL_OTHERS', { type: data.data.type })
    commit('SET_SELL_FETCHED_ATTRIBUTES', data.data.attributes)
    commit('SET_SELL_GEOPOINT', data.data.geopoint)
    commit('SET_SELL_LOCATIONS', data.data.locations)
    commit('SET_SELL_EMAILS', data.data.emails)
    commit('SET_SELL_PHONES', data.data.phones)
    commit('SET_SELL_IMAGES', data.data.media)
    commit('SET_SELL_CATALOG_DOMAIN', data.data.catalog_domain)
    commit('SET_CAT_MARKETABLE', data.data.category_marketable)
    commit('SET_SELL_FOR_SALE', data.data.for_sale)
    if (data.data.product) commit('SET_SELL_STOCK', data.data.product.stock) // FIXME
    if (data.data.product) commit('SET_SELL_SHIPPING_TYPE', data.data.product.shipping_type) // FIXME
  },

  getPub: ({commit, dispatch}, id) => api.get(`${urls.userPublications}/${id}`)
    .then(({data}) => { dispatch('setDraft', data) }),

  getDraft: ({commit, dispatch}, id) => api.get(`${urls.sell}/${id}`)
    .then(({data}) => { dispatch('setDraft', data) })
    .catch(err => {
      // return api.get(`${urls.publicationSheet}/${id}`)
    }),

  updateDraft: ({commit, state, getters}) => {
    const formData = {
      mla_category_id: state.mla_category_id,
      category_id: state.category_id,
      publication_status_id: state.publication_status_id,
      title: state.title,
      body: state.body,
      price: state.price,
      enable_questions: state.enable_questions,
      auto_republication: state.auto_republication,
      conditions: state.conditions,
      attributes: getters.attributes,
      for_sale: state.forSale,
      product: {
        stock : state.stock,
        //sku: state.sku,
        //discount: state.discount
        shipping_type: state.shipping_type
      },
      fields_filled: state.fields_filled,
    }

    // If setted_value_id is still null, set it to match setted_value
    // It's done here so it doesn't trigger the next attribute's suggestions fetch
    formData.attributes = formData.attributes.map(a => {
      if (!a.setted_value_id) a.setted_value_id = a.setted_value
      return a
    })

    return api.put(`${urls.sell}/${state.id}`, formData)
      .then(({data}) => { commit('SET_SELL_API_ERROR', false) })
      .catch(err => {
        commit('SET_SELL_API_ERROR', true)
        return Promise.reject(err)
      })
  },

  fetchImages: ({commit, state}) => api.get(`${urls.publications}/${state.id}/media`)
    .then(({data}) => {
      const images = data.data
      commit('SET_SELL_IMAGES', images)
    })
    .catch(err => {}),

  deleteImage: ({commit, dispatch, state}, id) => {
    const copy = state.images.filter(i => i.id === id)[0]
    commit('REMOVE_SELL_IMAGE', id)

    return api.delete(`${urls.publications}/${state.id}/media/${id}`)
      .then(({data}) => {})
      .catch(err => { commit('ADD_SELL_IMAGE', copy) })
  },

  uploadImage: ({commit, state}, {file, order}) => {
    const formData = new FormData()

    formData.append('image_file_name', file)
    formData.append('image_file_order', order)

    return api.post(`${urls.publications}/${state.id}/media`, formData)
      .then(({data}) => { commit('ADD_SELL_IMAGE', data.data) })
      .catch(err => { return Promise.reject(err) })
  },

  updateImageOrder: ({commit, state}, {id, order}) => {
    const formData = {
      image_file_order: order
    }

    return api.put(`${urls.publications}/${state.id}/media/${id}`, formData)
      .then(({data}) => { commit('UPDATE_SELL_IMAGE', data.data) })
      .catch(err => {})
  },

  setTitle: ({commit}, title) => { commit('SET_SELL_TITLE', title) },

  setBody: ({commit}, body) => { commit('SET_SELL_BODY', body) },

  addGeopoint: ({commit, state}, geopoint) => {
    const formData = {
      string: geopoint.string,
      latitude: geopoint.lat,
      longitude: geopoint.lon,
      city: geopoint.city,
      public: true
    }

    return api.post(`${urls.publications}/${state.id}/geopoints`, formData)
      .then(({data}) => { commit('SET_SELL_GEOPOINT', data.data) })
      .catch(err => {})
  },

  addLocalGeopoint: ({commit}, geopoint) => {
    const geo = {
      id: geopoint.id,
      string: geopoint.string,
      city: geopoint.city,
      coordinates: {
        lat: geopoint.lat,
        lon: geopoint.lon
      }
    }
    commit('SET_SELL_GEOPOINT', geo)
  },

  editGeopoint: ({commit, state}, geopoint) => {
    const formData = {
      string: geopoint.string,
      latitude: geopoint.lat,
      longitude: geopoint.lon,
      city: geopoint.city,
      public: true
    }

    return api.put(`${urls.publications}/${state.id}/geopoints/${geopoint.id}`, formData)
      .then(({data}) => { commit('SET_SELL_GEOPOINT', data.data) })
      .catch(err => {})
  },

  removeGeopoint: ({commit, state}, geo) => api.delete(`${urls.publications}/${state.id}/geopoints/${geo.id}`)
    .then(({data}) => { commit('SET_SELL_GEOPOINT', null) })
    .catch(err => {}),

  addLocation: ({commit, state}, location) => {
    const formData = {
      user_location_id: parseInt(location.id)
    }

    return api.post(`${urls.publications}/${state.id}/locations`, formData)
      .then(({data}) => { commit('SET_SELL_LOCATIONS', state.locations.concat(location)) })
      .catch(err => {})
  },

  removeLocation: ({commit, state}, loc) => api.delete(`${urls.publications}/${state.id}/locations/${loc.id}`)
    .then(({data}) => { commit('SET_SELL_LOCATIONS', state.locations.filter(l => l.id !== loc.id)) })
    .catch(err => {}),

  addPhone: ({commit, state}, phone) => {
    const formData = { user_phone_id: phone.id }

    return api.post(`${urls.publications}/${state.id}/phones`, formData)
      .then(({data}) => {
        commit('SET_SELL_PHONES', state.phones.concat(phone))
      })
  },

  removePhone: ({commit, state}, phone) => api.delete(`${urls.publications}/${state.id}/phones/${phone.id}`)
    .then(({data}) => {
      commit('SET_SELL_PHONES', state.phones.filter(p => p.id !== phone.id))
    }),

  addEmail: ({commit, state}, email) => {
    const formData = { user_email_id: email.id }

    return api.post(`${urls.publications}/${state.id}/emails`, formData)
      .then(({data}) => {
        commit('SET_SELL_EMAILS', state.emails.concat(email))
      })
  },

  removeEmail: ({commit, state}, email) => api.delete(`${urls.publications}/${state.id}/emails/${email.id}`)
    .then(({data}) => {
      commit('SET_SELL_EMAILS', state.emails.filter(e => e.id !== email.id))
    }),

  setPriceValue: ({commit}, value) => { commit('SET_SELL_PRICE_VALUE', value) },

  setPriceCurrency: ({commit}, cur) => { commit('SET_SELL_PRICE_CURRENCY', cur) },

  removeImage: ({commit}, image) => { commit('REMOVE_SELL_IMAGE', image) },

  setImages: ({commit}, images) => { commit('SET_SELL_IMAGES', images) },

  setFetchedAttributes: ({commit}, attrs) => { commit('SET_SELL_FETCHED_ATTRIBUTES', attrs) },

  updateAttribute: ({commit}, attr) => { commit('UPDATE_SELL_ATTRIBUTE', attr) },

  setOthers: ({commit}, options) => { commit('SET_SELL_OTHERS', options) },

  changePubStatusId: ({commit, state, dispatch}, status) => {
    commit('SET_SELL_PUB_STATUS_ID', status)
    return dispatch('updateDraft')
  },

  setPubStatus: ({commit, state, dispatch}, status) => {
    commit('SET_SELL_PUB_STATUS', status)
  },

  setHighlightRequested: ({commit}, value) => { commit('SET_SELL_HL_REQUESTED', value) },

  setHlValue: ({commit, state, getters, dispatch}, {key, val}) => {

    if (key === 'days') commit('SET_HL_VALUE', ['period_length', parseInt(val)])
    if (key === 'frontpage') {
      commit('SET_HL_VALUE', ['frontpage', val])
    }
    if (key === 'highlightType') {
      commit('SET_HL_VALUE', ['highlightType', [val]])
    }

    if (key === 'rotatingImages') {
      commit('SET_HL_VALUE', ['rotating_images', val])
    }

    if (key === 'band_code') {
      const value = typeof val === 'string' && val.length > 2 ? val : ''
      commit('SET_HL_VALUE', [key, value])
    }

    if (key === 'band_text') {
      const value = typeof val === 'string' && val.length > 2 ? val : undefined
      commit('SET_HL_VALUE', [key, value])
      return Promise.resolve()
    }

    if (key === 'band_color') {
      commit('SET_HL_VALUE', [key, val])
      return Promise.resolve()
    }

    return dispatch('fetchPriceCalculation')
  },

  fetchPriceCalculation: ({commit, state, getters}) => {
    const order = state.highlightRequested ? getters.highlightOrder : getters.publicationOrder
    return api.post(urls.publicationOrderPrice, order)
      .then(({data}) => {
        commit('SET_HL_CALC', data.data)
      })
  },

  getCheapestHighlight: ({commit, state, getters}) => {
    const order = getters.cheapestHighlight
    return api.post(urls.publicationOrderPrice, order)
      .then(({data}) => {
        commit('SET_HL_CALC', data.data)
      })
  },

  setPaymentGateway: ({commit}, gateway) => {
    commit('SET_PAYMENT_GATEWAY', gateway)
  },

  setPubId: ({commit}, id) => {
    commit('SET_SELL_ID', id)
  },

  createPublicationOrder: ({commit, getters}, order) => api.post(urls.publicationOrder, order)
    .then(({data}) => {
      commit('SET_HL_FINAL', data.data)
      const hl_pending = data.data.highlight_pending
      if (hl_pending) commit('SET_SELL_HIGHLIGHT_PENDING', hl_pending)
    }),

  setCheckRequiredFields: ({commit}, value) => { commit('SET_SELL_CHECK_REQUIRED_FIELDS', value) },

  setFieldsFilled: ({commit}, value) => { commit('SET_SELL_FIELDS_FILLED', value) },

  addAttrWithError: ({commit}, value) => { commit('ADD_SELL_ATTR_WITH_ERRORS', value) },

  removeAttrWithError: ({commit}, value) => { commit('REMOVE_SELL_ATTR_WITH_ERRORS', value) },

  setStock: ({commit}, stock) => { commit('SET_SELL_STOCK', stock) },

  setForSale: ({commit}, value) => { commit('SET_SELL_FOR_SALE', value) },

  setShippingType: ({commit}, value) => { commit('SET_SELL_SHIPPING_TYPE', value) },

  getRemainingPubs: ({commit}, id) => api.get(`${urls.sellCategories}/${id}/limits`)
    .then(({data}) => {
      commit('SET_SELL_LIMIT_ON_CATEGORY', data.data.limit_on_category)
      commit('SET_SELL_REMAINING_PUBS', data.data.remaining_publications)
    }),

  getAttributeSuggestions: ({commit, state, getters}, {id, index}) => {
    let formData = {}
    const filledRequiredAttributes = getters.required.filter(a => !!a.setted_value && !a.mpv_fixed)
    for (let i = 0; i < filledRequiredAttributes.length && i < index; i++) {
      const f = filledRequiredAttributes[i]
      if (f.id === id) {
        break
      } else {
        const container = {}
        container[f.id] = f.setted_value
        formData = {
          ...formData,
          ...container
        }
      }
    }
    return api.post(`${urls.categoriesSuggest}/${state.catalogDomain}/attributes/${id}`, formData)
      .then(({data}) => {
        commit('ADD_SELL_ATTRIBUTE_SUGGESTIONS', {attributeId: id, suggestions: data.data})
      })
  },

  setAttributeSuggestions: ({commit, state}, attributeId, attributeSuggestions) => {
    commit('SET_SELL_ATTRIBUTE_SUGGESTIONS', { attributeId: attributeId, suggestions: attributeSuggestions })
  },

  removeAttributeSuggestions: ({commit}, index) => {
    commit('REMOVE_SELL_ATTRIBUTE_SUGGESTIONS', index)
  },

  setIsFetching: ({commit}, value) => {
    commit('SET_SELL_IS_FETCHING', value)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/sell-actions.js